import { graphql } from '../../../../gql'

export const GET_POSTING_SCHEDULE_INFO = graphql(/* GraphQL */ `
  query GetPostingScheduleInfo($input: ChannelInput!) {
    channel(input: $input) {
      id
      postingSchedule {
        day
        paused
        times
      }
    }
  }
`)
